// extracted by mini-css-extract-plugin
module.exports = {"MonitorInstallationSpinner":"MonitorInstallationSpinner_35CPi","MonitorInstallationMessage":"MonitorInstallationMessage_og8Sj"};